import Alert from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { SubscriptionOfferStatus } from "@/gql/__generated__/graphql";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

interface Props {
  status: SubscriptionOfferStatus;
}

const BackButton = () => (
  <Link to="/">
    <Button
      variant="secondary"
      className="block mt-4"
      data-testid="alert-redirect-button"
    >
      <ArrowLeft
        strokeWidth={1.6}
        className="h-[20px] w-[20px] relative -left-2 -top-0.5 inline"
      />
      Go to Numerous
    </Button>
  </Link>
);

export const InvalidStatusAlert = ({ status }: Props) => {
  switch (status) {
    case SubscriptionOfferStatus.Accepted:
      return (
        <Alert
          title="The subscription offer has already been accepted!"
          description={
            <>
              This offer has previously been accepted.
              <BackButton />
            </>
          }
          data-testid="accepted-alert"
        />
      );
    case SubscriptionOfferStatus.Rejected:
      return (
        <Alert
          title="The subscription offer has been declined!"
          description={
            <>
              It looks like this offer has previously been declined.
              <br />
              Please contact the organization to get a new offer.
              <BackButton />
            </>
          }
          data-testid="rejected-alert"
        />
      );
    case SubscriptionOfferStatus.Withdrawn:
      return (
        <Alert
          title="The subscription offer has been withdrawn."
          description={
            <>
              It looks like the organization who sent you this offer has since
              withdrawn the offer.
              <br />
              Please contact the organization to get a new offer.
              <BackButton />
            </>
          }
          data-testid="withdrawn-alert"
        />
      );
    case SubscriptionOfferStatus.Expired:
      return (
        <Alert
          title="The subscription offer has expired!"
          description={
            <>
              This offer has expired.
              <BackButton />
            </>
          }
          data-testid="expired-alert"
        />
      );
    default:
      return (
        <Alert
          title="Unknown status"
          description={
            <>
              This subscription offer contains an unknown status. Please report
              this issue.
              <BackButton />
            </>
          }
          data-testid="unknown-alert"
        />
      );
  }
};
